import { render, staticRenderFns } from "./BillingOrderDialogHoldOrder.vue?vue&type=template&id=52e62e05&scoped=true"
import script from "./BillingOrderDialogHoldOrder.vue?vue&type=script&lang=js"
export * from "./BillingOrderDialogHoldOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e62e05",
  null
  
)

export default component.exports